import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jtn4n27qaj: FaireBrandEntity = {
  token: "b_jtn4n27qaj",
  type: "brand",
  name: "Noodo",
  avatarUrl:
    "https://cdn.faire.com/fastly/64c2ec7d77bbfab338782667e8330b4e8d4a6d83a7822e98e34439ad6d57e10c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f3460baf7015f94296c10503529ae28bf71f5fe0c40b63b01e85f0383f6831c7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/64c2ec7d77bbfab338782667e8330b4e8d4a6d83a7822e98e34439ad6d57e10c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f3460baf7015f94296c10503529ae28bf71f5fe0c40b63b01e85f0383f6831c7.png",
  location: "Southington, CT, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 1,
  isTopShop: true,
  isInsider: true,
  description:
    "Our brand Noodo was founded by a father-daughter duo that grew up around Italian cooking where sauce simmered for hours, ingredients were fresh from a garden, and flavor always came first. Those recipes shaped how we think about food, comforting, deeply flavorful, and made with intention. But as we looked at the sauce aisle today, we saw a large gap. Many options either prioritize convenience and cut corners on ingredients, or focus on health trends at the expense of flavor and tradition.\n\nWe started Noodo to prove you shouldn’t have to choose. Noodo makes tomato sauces rooted in traditional Italian process of removing the skins and the seeds of the tomatoes prior to slow simmering our sauce. Each sauce starts with peeled tomatoes and real ingredients, then slow-simmered for hours to bring out natural sweetness so that you don't have to simmer it. What makes Noodo different is the addition of bone broth, a subtle but powerful ingredient that adds richness, depth of flavor, and natural protein without changing the classic taste people expect from a great tomato sauce.",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:18:07.936Z",
    importedBy: "entity-db-cli",
  },
};
